import { render } from "./salesOverview.vue?vue&type=template&id=096bb032"
import script from "./salesOverview.vue?vue&type=script&lang=js"
export * from "./salesOverview.vue?vue&type=script&lang=js"

import "./salesOverview.vue?vue&type=style&index=0&id=096bb032&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__